module.exports = __webpack_public_path__ + "img/clogo.7da98eb9.png";